














import IBook from "@/Models/Book/IBook";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class ReadingList extends Vue
{
    private books: IBook[] = [
        {
            Author: "Imran Ahmad",
            Link: "https://www.amazon.com/Algorithms-Every-Programmer-Should-Know/dp/1789801214",
            Title: "40 Algorithms Every Programmer Should Know"
        },
        {
            Author: "Massimo Banzi and Michael Shiloh",
            Link: "https://www.amazon.com/Getting-Started-Arduino-Electronics-Prototyping/dp/1449363334",
            Title: "Getting Started With Arduino"
        }
    ];
}
